import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { formatDate } from '../../../getDeadline.js';
import AgreementReceipt from '../../../agreementReceipt.jsx';
import { data as agreementDataPropTypes } from '../../../agreementPropTypes';
import partnerPropTypes from '../../../partnerPropTypes';
import Page from '../../../page.jsx';

const AgreementSentDetails = ({ agreement, partner }) => (
    <Page heading={`Venter på svar fra ${partner.name}`}>
        <div>
            <p>
                {partner.name} må bekrefte at dere er enige om denne avtalen
                innen
                <span className="strong">
                    {' '}
                    {formatDate(agreement.acceptDeadline)}
                </span>.
            </p>

            <div className="r-phl r-pbl">
                <AgreementReceipt
                    agreement={agreement}
                    partner={partner}
                    role="BUYER"
                />
            </div>

            <div className="r-pal">
                <Link to="/samtale" className="button fullwidth">
                    OK
                </Link>
            </div>
        </div>
    </Page>
);

AgreementSentDetails.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    partner: partnerPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        agreement: state.agreement.data,
        partner: state.partner,
    };
}

export default connect(mapStateToProps)(AgreementSentDetails);



// WEBPACK FOOTER //
// ./safeTrade/buyer/agreement/statusDetails/agreementSentDetails.jsx